import Vue from 'vue'
import Router from 'vue-router'
import {getStore} from '@/util/store'
Vue.use(Router)

let commonRoutes = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/login')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/pay/index')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('@/views/pay/result')
  },
  // 企业码扫二维码登录
  {
    path: '/scancodelogin',
    name: 'scancodelogin',
    component: () => import('@/components/scancodelogin')
  },
  // 修改密码
  {
    path: '/password',
    name: 'password',
    component: () => import('@/components/password')
  },
  // 404
  {
    path:'*',
    name:'login',
    component: () => import('@/components/login')
  },
  // 计算器：根据mn和时间获取识别码
  {
    path: '/test-calculator',
    name: 'test-calculator',
    component: () => import('@/views/test-calculator/index')
  },
  // 反控界面
  {
    path: '/counter-control',
    name: 'counter-control',
    component: () => import('@/views/counter-control/index')
  },
  // 非企业扫码上报
  {
    path: '/business-operation',
    name: 'business-operation',
    component: () => import('@/views/business-operation/index')
  },
  // 企业扫码上报
  {
    path: '/client-business-operation',
    name: 'client-business-operation',
    component: () => import('@/views/client-business-operation/index')
  },
  //企业查询详情
  {
    path: '/law-corp-detail',
    name: 'law-corp-detail',
    component: () => import('@/views/law-corp-search/detail')
  },
  //工单查询详情
  {
    path: '/law-work-detail',
    name: 'law-work-detail',
    component: () => import('@/views/law-work-order/detail')
  },
  //企业上报
  {
    path: '/law-work-report',
    name: 'law-work-report',
    component: () => import('@/views/law-work-order/report')
  },
  //执法反馈
  {
    path: '/law-work-feedback',
    name: 'law-work-feedback',
    component: () => import('@/views/law-work-order/feedback')
  },
  //运维详情
  {
    path: '/law-work-ops-detail',
    name: 'law-work-ops-detail',
    component: () => import('@/views/law-work-order/ops-detail')
  },
  // 运维复核
  {
    path: '/operation-record-recheck',
    name: 'operation-record-recheck',
    component: () => import('@/views/operation-record/recheck')
  },
  // 帮助内容的列表
  {
    path: '/helplist',
    name: 'helplist',
    component: () => import('@/views/personcenter/helplist')
  },
  // 帮助内容的详情
  {
    path: '/helpdetail',
    name: 'helpdetail',
    component: () => import('@/views/personcenter/helpdetail')
  },

  //合同信息
  {
    path: '/agent/contract',
    name: 'contract',
    component: () => import('@/views/agent/contract')
  },
  //工单详情信息
  {
    path: '/agent/orderdetail',
    name: 'orderdetail',
    component: () => import('@/views/agent/orderdetail')
  },
];

// 非企业
let normalRoutes = [
  // {
  //     path: '/',
  //     name: 'home',
  //     component: () => import('@/views/home/index')
  // },
  // 实时监控
  // {
  //     path: '/realtime-monitor',
  //     name: 'realtime-monitor',
  //     component: () => import('@/views/realtime-monitor/index')
  // },
  // 单企业分析图表
  {
      path: '/realtime-monitor-chart',
      name: 'realtime-monitor-chart',
      component: () => import('@/views/realtime-monitor/chart')
  },
  // 排放状态企业列表
  // {
  //     path: '/realtime-monitor-list',
  //     name: 'realtime-monitor-list',
  //     component: () => import('@/views/realtime-monitor/list')
  // },
  // 单企业监控
  {
      path: '/business-monitor',
      name: 'business-monitor',
      component: () => import('@/views/business-monitor/index')
  },
  // 单企业监控详情
  {
      path: '/business-monitor-detail',
      name: 'business-monitor-detail',
      component: () => import('@/views/business-monitor/detail')
  },
  // 单企业监控 - 管理企业信息
  {
    path: '/business-monitor-manage',
    name: 'business-monitor-manage',
    component: () => import('@/views/business-monitor/manage')
  },
  // 单企业监控 - 管理企业信息 - 纠错界面
  {
      path: '/business-monitor-correct',
      name: 'business-monitor-correct',
      component: () => import('@/views/business-monitor/correct')
  },
  // 告警查询
  {
      path: '/warning-search',
      name: 'warning-search',
      component: () => import('@/views/warning-search/index')
  },
  // 运维工单图表
  // {
  //     path: '/operation-record',
  //     name: 'operation-record',
  //     component: () => import('@/views/operation-record/summary')
  // },
  // 运维打卡
  {
      path: '/operation-record-clock',
      name: 'operation-record-clock',
      component: () => import('@/views/operation-record/clock')
  },
  // 运维列表
  {
      path: '/operation-record-index',
      name: 'operation-record-index',
      component: () => import('@/views/operation-record/index')
  },
  // 运维初审
  {
      path: '/operation-record-firstcheck',
      name: 'operation-record-firstcheck',
      component: () => import('@/views/operation-record/firstcheck')
  },

  // 运维详情页
  {
      path: '/operation-record-detail',
      name: 'operation-record-detail',
      component: () => import('@/views/operation-record/detail')
  },

  // 运维工单列表页
  {
    path: '/work-order-list',
    name: 'work-order-list',
    component: () => import('@/views/work-order/list')
  },
  // 运维工单安装流程页
  {
    path: '/work-order-install',
    name: 'work-order-install',
    component: () => import('@/views/work-order/install')
  },
  // 运维工单拆除流程页
  {
    path: '/work-order-dismantle',
    name: 'work-order-dismantle',
    component: () => import('@/views/work-order/dismantle')
  },
  // 运维工单详情页
  {
    path: '/work-order-detail',
    name: 'work-order-detail',
    component: () => import('@/views/work-order/detail')
  },
]

// 企业端
let businessRoutes = [
  // 首页
  // {
  //   path: '/',
  //   name: 'client-home',
  //   component: () => import('@/views/client-home/index')
  // },
  // 单企业分析图表
  {
    path: '/client-realtime-monitor-chart',
    name: 'client-realtime-monitor-chart',
    component: () => import('@/views/client-realtime-monitor/chart')
  },
  // 排放状态企业列表
  // {
  //   path: '/client-realtime-monitor-list',
  //   name: 'client-realtime-monitor-list',
  //   component: () => import('@/views/client-realtime-monitor/list')
  // },
  // 单企业监控
  {
    path: '/client-business-monitor',
    name: 'client-business-monitor',
    component: () => import('@/views/client-business-monitor/index')
  },
  // 单企业监控详情
  {
    path: '/client-business-monitor-detail',
    name: 'client-business-monitor-detail',
    component: () => import('@/views/client-business-monitor/detail')
  },
  // 运维列表
  // {
  //   path: '/client-operation-record-index',
  //   name: 'client-operation-record-index',
  //   component: () => import('@/views/client-operation-record/index')
  // },
  // 运维详情页
  {
    path: '/client-operation-record-detail',
    name: 'client-operation-record-detail',
    component: () => import('@/views/client-operation-record/detail')
  },
  // 清洗记录
  // {
  //   path: '/client-clean',
  //   name: 'client-clean',
  //   component: () => import('@/views/client-clean/index')
  // },
  // 清洗记录-上传清洗内容
  {
    path: '/client-clean-upload',
    name: 'client-clean-upload',
    component: () => import('@/views/client-clean/upload')
  },
  // 我的信息
  // {
  //   path: '/client-personcenter',
  //   name: 'client-personcenter',
  //   component: () => import('@/views/client-personcenter/index')
  // },
]

let lawRoutes=[
  //首页
  // {
  //   path: '/',
  //   name: '/law-home',
  //   component: () => import('@/views/law-home/index')
  // },
  //工单
  // {
  //   path: '/law-work-order',
  //   name: 'law-work-order',
  //   component: () => import('@/views/law-work-order/index')
  // },
  // //企业查询
  // {
  //   path: '/law-corp-search',
  //   name: 'law-corp-search',
  //   component: () => import('@/views/law-corp-search/index')
  // },

]
// 根据条件注入路由
let routesObj = []
routesObj = commonRoutes
let userInfo = getStore({name: 'userInfo'})
let menuAll = getStore({name: 'menuAll'})
if(userInfo) {
  let corp_id = userInfo.corp_id
  if(corp_id == "" || corp_id == null || corp_id == undefined) {
    if (userInfo.role_type.indexOf("6") >= 0) {
      for(let i in lawRoutes) {
        routesObj.push(lawRoutes[i]);
      }
    } else {
      for(let i in normalRoutes) {
        routesObj.push(normalRoutes[i]);
      }
    }

    console.log("router文件夹下的非企业路由",routesObj)
  } else {
    for(let i in businessRoutes) {
      routesObj.push(businessRoutes[i])
    }
    console.log("router文件夹下的企业路由",routesObj)
  }
  if (menuAll) {
    menuAll.forEach((item) => {
      let corp_id = userInfo.corp_id
      if (item.path=="/"){
        if(corp_id == "" || corp_id == null || corp_id == undefined) {
          if (userInfo.role_type.indexOf("6")>=0){
            routesObj.push({
              path: '/',
              name: item.name,
              component: () => import('@/views/law-home/index')
            });
          } else {
            routesObj.push({
              path: '/',
              name: item.name,
              component: () => import('@/views/home/index')
            });
          }
        } else {
          routesObj.push({
            path: '/',
            name: 'client-home',
            component: () => import('@/views/client-home/index')
          });
        }
      } else {
        routesObj.push({
          path: item.path,
          name: item.name,
          component: () => import('@/views' + item.path)
        });
      }
    });
  }
}

export default new Router({
  routes: routesObj
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js